import { Link } from "react-router-dom";
import { Col, Badge } from "reactstrap";
import { Href } from "../../../utils/Constant";
import { H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { useAuth } from "../../../hooks/useAuth";
import { Globe } from "react-feather";

const LeftHeader = () => {
  const { user, hasRole } = useAuth();

  // Obtener nombre del usuario
  const userName = user?.name || user?.email || "Usuario";
  
  // Obtener idioma del usuario
  const userLanguage = user?.language || "ES";
  
  // Mapear código de idioma a nombre completo
  const languageMap: { [key: string]: string } = {
    "ES": "Español",
    "EN": "English",
    "FR": "Français",
    "PT": "Português",
  };
  
  const languageName = languageMap[userLanguage] || userLanguage;
  
  // Mensaje personalizado según el rol
  const getWelcomeMessage = () => {
    if (!user) return "Hola";
    
    try {
      if (hasRole("admin")) {
        return "Aquí está lo que está pasando con tu sistema hoy.";
      } else if (hasRole("lawyer")) {
        return "Aquí están tus consultas pendientes de hoy.";
      } else if (hasRole("client")) {
        return "Aquí está el estado de tus consultas legales.";
      }
    } catch (error) {
      console.error('Error al verificar rol:', error);
    }
    
    return "Hola, bienvenido a tu panel de control.";
  };

  return (
    <Col xl="5" lg="4" md="4" sm="3" className="left-header p-0" style={{ display: 'none' }}>
      <div>
        <Link className="toggle-sidebar" to={Href}>
          <i className="iconly-Category"></i>
        </Link>
        <div className="d-flex align-items-center gap-2">
          <Image className="mt-0" src={dynamicImage("hand.gif")} alt="hand-gif" />
        </div>
      </div>
      <div className="welcome-content d-xl-block d-none">
        <Col xs="12" className="d-flex align-items-center gap-2 flex-wrap">
          <P className="text-truncate mb-0">
            {getWelcomeMessage()}
          </P>
          {userLanguage && (
            <Badge color="light" className="d-flex align-items-center gap-1">
              <Globe size={12} />
              <span>{languageName}</span>
            </Badge>
          )}
          {user?.role && (
            <Badge color="primary" style={{ color: '#fff' }}>
              {user.role.name}
            </Badge>
          )}
        </Col>
      </div>
    </Col>
  );
};

export default LeftHeader;
